import { render, staticRenderFns } from "./AupHero.vue?vue&type=template&id=0c8d8987&"
import script from "./AupHero.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AupHero.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AupHero.vue?vue&type=style&index=0&id=0c8d8987&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports